<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Detalhes da Denúncia</h1>

	        <router-link :to="{name: 'Denuncias', params: {get: 'Denuncias'} }">
	        	<button class="btn btn-sm btn-success">Voltar</button>
	        </router-link>
	    </div>

		<div class="d-sm-flex justify-content-between mb-3">
			<div class="p-2 mr-1">
				<b>ID: </b> {{ denuncia.id }}
			</div>

			<div class="p-2 mr-1">
				<b>Protocolo: </b> {{ denuncia.protocolo }}
			</div>

			<div class="p-2 mr-1">
				<b>Origem: </b> {{ Phone(denuncia.origem) }}
			</div>

			<div class="p-2 mr-1">
				<b>Data: </b> {{ denuncia.created_at | moment("DD/MM/YYYY") }}
			</div>

			<div class="p-2 mr-1">
				<b>Hora: </b> {{ convert_hor(denuncia.created_at) | moment("HH:mm:ss") }}
			</div>
		</div>

		<hr>

		<player v-if="denuncia.canal === 1" ref="wavesurfer" :audio_hash="audio" />

        <div class="row" v-else>
            <div class="col-12">
                <div class="form-group">
                    <label>Denúncia</label>
                    <textarea class="form-control" readonly rows="6" v-model="denuncia.denuncia"></textarea>
                </div>
            </div>
        </div>

		<div v-if="denuncia.anexo_count">
			<div class="d-sm-flex justfy-content-between">
				<div class="p-2" v-for="anexo in denuncia.anexo" :key="anexo.id">
					<input type="hidden" v-if="carrega_anexo(anexo)"> 
					<button class="btn btn-sm btn-light" @click="view_anexo(anexo)">{{ anexo.nome }}</button>
				</div>
			</div>

			<hr>
		</div>

		<div class="row">
	    	<table class="table table-striped table-hover table-sm table-responsive-xl">
	    		<thead align="center">
	    			<th @click="orderBy('id')"         >ID         <font-awesome-icon v-if="direction.by == 'id'"          :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('created_at')" >DATA       <font-awesome-icon v-if="direction.by == 'created_at'"  :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('updated_at')" >HORA       <font-awesome-icon v-if="direction.by == 'updated_at'"  :icon="order_icon" size="xs" /></th>

	    			<th @click="orderBy('anexo_count')">
						<font-awesome-icon icon="paperclip" title="Anexos" class="info" />
						<font-awesome-icon v-if="direction.by == 'anexo_count'" :icon="order_icon" size="xs" />
					</th>

	    			<th @click="orderBy('complemento')">COMPLEMENTO<font-awesome-icon v-if="direction.by == 'complemento'" :icon="order_icon" size="xs" /></th>
	    			<th></th>
	    		</thead>

	    		<transition mode="out-in" name="leftIn">
					<tbody v-if="complementos" align="center">
		    			<tr v-for="(row, index) in complementos.data" :key="index">
							<td>{{ row.id }}</td>
							<td>{{ row.created_at | moment("DD/MM/YYYY") }}</td>
							<td>{{ convert_hor(row.created_at) | moment("HH:mm:ss") }}</td>
							<td>{{ row.anexo_count }}</td>
							<td>{{ row.complemento }}</td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(row)" /></td>
						</tr>
		    		</tbody>
		    		<Loading v-else />
				</transition>
	    	</table>
	    </div>

	    <controls :data="constrol_data" @refresh="navigate" />
		<modal :complemento="modal_data" />
		<mAnexo :attachment="mAnexo_data" name="modal-anexo" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import controls from "@/components/Tools/Table_Control.vue"
	import player   from "@/components/Tools/Player.vue"
	import modal    from "@/components/Modal/Denuncia/Complemento"
    import mAnexo   from '@/components/Modal/anexo'

	export default {
		name: "denuncia-details",
		mixins: [api, replace],
		components: { controls, player, modal, mAnexo },

		data() { return {
			denuncia: { canal: 1 },
			complementos: null,
			constrol_data: {},
			audio: null,
			modal_data: {},
			mAnexo_data: {},
			pagination: "10?",
			direction: { order: "desc", by: "id" },
		}},

		computed: {
			logotipo() { return this.$store.state.config.logotipo },

			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			}
		},

		async created() {
			await this.get_denuncia()
			await this.get_audio()
			await this.get_data()
		},

		methods: {
			async get_denuncia() {
				const response = await this.GET("Denuncia", this.$route.params.denuncia_id)
				if ( response.status == 'success' ) this.denuncia = response.result
			},

			async get_audio() {
				const response = await  this.GET("Audio", this.denuncia.gravacao_id)
				this.audio = response.file || null
			},

			async carrega_anexo(anexo_aux){
				const response = await this.POST("Denuncia/Anexo/pegaArquivo",{ path: anexo_aux.path, tipo: anexo_aux.type})
				anexo_aux.file = response
			},

			async get_data() {
				const response = await this.GET("Denuncia/Complemento", `Paginate/${this.pagination}${this.ordenation}&denuncia_id=${this.$route.params.denuncia_id}`)

				if ( response.status == "success" )
					this.complementos = response.result

				this.constrol_data = {
					current_page: this.complementos.current_page,
					last_page:    this.complementos.last_page,
					per_page:     this.complementos.per_page,
					total:        this.complementos.total,
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			view(payload) {
				this.modal_data = payload
				$("#modal-complemento").modal()
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

            view_anexo(payload) {
                this.mAnexo_data = payload
                $("#modal-anexo").modal()
            },
		},
	}
</script>